import React, { useState } from 'react'
import phoneIcon from '../../../../media/svg/phone-icon.svg'
import emailIcon from '../../../../media/svg/email-icon.svg'
import webIcon from '../../../../media/svg/web-icon.svg'
import Button from './button/Button'
import { ToastContainer, toast } from 'react-toastify';
import axios, { AxiosError } from "axios";

import {
    webApiContactoConcurso2025
} from "../../../../routes/endpoints";
import 'react-toastify/dist/ReactToastify.css';

const Contacto = () => {

    const [showLoader, setShowLoader] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [state, setState] = useState({
        name: "",
        lastName: "",
        phone: "",
        email: "",
        message: ""
      });

    const handleSubmit = (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        const userData = {
            nombre: state.name,
            apellido: state.lastName,
            telefono: state.phone,
            email: state.email,
            mensaje: state.message
        };

        if (userData.nombre.length === 0 || userData.apellido.length === 0 || userData.telefono.length === 0 || userData.email.length === 0 || userData.mensaje.length === 0) {
            showErrorToastMessage('Debes llenar todos los campos')
        } else {
            setShowLoader(true)
            setDisabled(true)
            axios.post(webApiContactoConcurso2025, userData).then((response) => {
                setShowLoader(false)
                setDisabled(false)
                showToastMessage()
                setState({  name: "",
                lastName: "",
                phone: "",
                email: "",
                message: "" })
            }).catch((reason: AxiosError) => {
                setShowLoader(false)
                setDisabled(false)
                showErrorToastMessage(reason.message)
                setState({  name: "",
                lastName: "",
                phone: "",
                email: "",
                message: "" })
            })
        }
    };

    const handleChange = (e: React.ChangeEvent<any>) => {
        const value = e.target.value;
         setState({
           ...state,
           [e.target.name]: value
        });
    };

    const handleCancel = (e:  React.ChangeEvent<any>) => {
        e.preventDefault();
        setState({  name: "",
        lastName: "",
        phone: "",
        email: "",
        message: "" })
    };

    const showErrorToastMessage = (error:string) => {
        toast.error(error, { position: "top-right" });
    };

    const showToastMessage = () => {
        toast.success('Tu mensaje fue enviado al equipo de TEPJF', { position: "top-right" });
    };
  
    return (
        <div className="container-fluid section-home pb-5" id="contacto">
            <ToastContainer />
            <div className="row justify-content-center">
                <div className="col-12 anchor-section">
                </div>
                <div className="col-md-8 inner-sections">
                    <div className="title-tiktok-info">
                        <h2>Contacto para dudas</h2>
                    </div>
                    <div className="container-inner-info p-4">
                        <div className="geton-section-grid">
                            <div className="inner-geton">
                                <div className="icon-form">
                                    <img src={phoneIcon} alt="Teléfono" />
                                </div>
                                <p>55 5728 - 2300 Ext. 2226, 2926 y 2489</p>
                            </div>
                            <div className="inner-geton">
                                <div className="icon-form">
                                    <img src={emailIcon} alt="Teléfono" />
                                </div>
                                <p>tiktok.transparencia@te.gob.mx</p>
                            </div>
                            <div className="inner-geton">
                                <div className="icon-form">
                                    <img src={webIcon} alt="Teléfono" />
                                </div>
                                <p>www.te.gob.mx/transparencia-home</p>
                            </div>
                        </div>
                        <div className="geton-form mt-2">
                            <form onSubmit={handleSubmit}> 
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="inputNombre" className="form-label label-geton-form">Nombres</label>
                                        <input type="text" name='name' className="input-geton form-control" id="inputNombre" required value={state.name} onChange={handleChange} disabled={false}/>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="inputApellido" className="form-label label-geton-form" >Apellidos</label>
                                        <input type="text"  name='lastName' className="input-geton form-control" id="inputApellido" required value={state.lastName} onChange={handleChange}/>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="inputTelefono" className="form-label label-geton-form">Telefono</label>
                                        <input type="text" name='phone' className="input-geton form-control" id="inputTelefono" required value={state.phone} onChange={handleChange}/>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="inputEmail" className="form-label label-geton-form">Email</label>
                                        <input type="text" name='email' className="input-geton form-control" id="inputEmail" required value={state.email} onChange={handleChange}/>
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="inputMessage" className="form-label label-geton-form">Mensaje:</label>
                                        <textarea name="message" id="" cols={30} rows={10} className="input-geton form-control textarea-geton" required value={state.message} onChange={handleChange}></textarea>
                                    </div>
                                    <div className="col-12 d-flex justify-content-center mt-3">
                                        <Button onSubmit={handleSubmit} text={'Envíar'} loading={showLoader} disabled={disabled} className={'btn-blue btn-general'} />
                                        <button className="btn-pink btn-general" onClick={handleCancel}>Cancelar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Contacto
